<div id="chat" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg primary"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- CONTENT HEADER -->
        <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
            <h2 class="m-0">Chat</h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
          <!-- CONTENT TOOLBAR -->
          <div class="toolbar px-24 py-8">
              <span>Start a conversation with technical support staff</span>
          </div>
          <!-- / CONTENT TOOLBAR -->

            <mat-sidenav-container>

                <!-- LEFT SIDENAV -->
                <mat-sidenav class="sidenav" position="start" opened="true" mode="side"
                             fuseMatSidenavHelper="chat-left-sidenav" matIsLockedOpen="gt-md">
                    <chat-left-sidenav></chat-left-sidenav>
                </mat-sidenav>
                <!-- / LEFT SIDENAV -->

                <!-- CONTENT -->
                <chat-start *ngIf="!selectedChat"></chat-start>

                <chat-view *ngIf="selectedChat"></chat-view>
                <!-- / CONTENT -->

                <!-- RIGHT SIDENAV -->
                <mat-sidenav class="sidenav" position="end" opened="false" mode="over"
                             fuseMatSidenavHelper="chat-right-sidenav">
                    <chat-right-sidenav></chat-right-sidenav>
                </mat-sidenav>
                <!-- / RIGHT SIDENAV -->

            </mat-sidenav-container>

        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

</div>
